<template>
    <footer id="footer" class="mt-5">
        <div class="container">
            <div class="row">
                <div class="col-md-3 col-12 main_col">
                    <img :src="logo.src" class="foot_logo" :alt="logo.title">
                    <div class="link_col links_columns1" v-if="links_columns1.visible">
                        <ul>
                            <li v-for="(link,index) in links_columns1.links" :key="index" v-if="links_columns1.links">
                                <a :href="link.link" v-html="link.text"></a>
                            </li> 
                        </ul>
                    </div>
                </div>
                <div class="col-md-9 col-12 main_col">
                    <div id="cols2">
                        <div class="row">
                            <div class="col-12 copyright" v-if="copyright.visible" v-html="copyright.text">
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-12 col-md-4 col-lg-4 link_col links_columns2">
                                       <ul v-if="links_columns2.visible">
                                            <li v-for="(link,index) in links_columns2.links" :key="index">
                                                <a :href="link.link" v-html="link.text"></a>
                                            </li> 
                                        </ul>
                                        <div v-if="links_columns2.html" v-html="links_columns2.html"></div>
                                        <!--   SOCIAL ICONS , IT WILL DISPLAY IN SM,MD,LG,XL  -->
                                        <div class="col-12 social-icon">
                                            <ul class="list-unstyled m-0 pt-2" style="text-align:right">
                                                <li class="footer-social-icon d-inline mr-1" v-if="fburl">
                                                    <a v-bind:href="fburl" target="_blank" alt="Facebook pagina" title="Facebook pagina">
                                                        <i class="fab fa-facebook-square"></i>
                                                    </a>
                                                </li>
                                                <li class="footer-social-icon d-inline" v-if="instagramurl">
                                                    <a alt="Instagram pagina" title="Instagram pagina" v-bind:href="instagramurl" target="_blank">
                                                        <i class="fab fa-instagram"></i>
                                                    </a>
                                                </li>
                                                <li class="footer-social-icon d-inline" v-if="tiktokurl">
                                                    <a alt="Tiktok pagina" title="Tiktok pagina" v-bind:href="tiktokurl" target="_blank">
                                                        <i class="fab fa-tiktok"></i>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4 col-lg-4 link_col links_columns3">
                                        <ul v-if="links_columns3.visible">
                                            <li v-for="(link,index) in links_columns3.links" :key="index">
                                                <a :href="link.link" v-html="link.text"></a>
                                            </li> 
                                        </ul>
                                        <div v-if="links_columns3.html" v-html="links_columns3.html"></div>
                                    </div>
                                    <div class="col-12 col-md-4 col-lg-4 link_col links_columns4">
                                        <ul v-if="links_columns4.visible">
                                            <li v-for="(link,index) in links_columns4.links" :key="index">
                                                <a :href="link.link" v-html="link.text"></a>
                                            </li> 
                                        </ul>
                                        <div v-if="links_columns4.html" v-html="links_columns4.html"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script> 

export default {
    name:'footer-links',
    props:{
        logo:Object,
        copyright:Object,
        links_columns1:Object,
        links_columns2:Object,
        links_columns3:Object,
        links_columns4:Object,
        fburl:String,
        instagramurl:String,
        tiktokurl:String,
    }
}
</script>

<style scoped>
    #footer{
        padding: 40px 120px;
        padding-top: 15px;
    }
    .link_col{
        display: inline-block;
    }
    .foot_logo{
        max-width: 220px !important;
    }
    ul{
        margin:0px;
        padding: 0px;
        list-style: none;
    }
    ul li a{
        color:black;
        font-size: 0.9rem;
    }
    .copyright{
        margin-top: 10px;
        margin-bottom:35px;
        text-align: right;
        font-size: .75rem;
    }

    .links_columns1{
        margin-top:20px;
        display: block;
    } 
    .links_columns1 ul{
        text-align: left;
    }
    .link_col{
        vertical-align: top;
    }

    @media (max-width: 992px){
         #footer{
            padding: 40px 70px;
        }
        .foot_logo{
            max-width: 200px !important;
        }
    }

     @media (max-width:792px){
         #footer{
            padding: 40px 50px;
        }
        .foot_logo{
            max-width: 150px !important;
        }
    }
    @media (max-width:559px){
            #footer{
            padding: 40px 20px;
        }
        .foot_logo{
            max-width: 150px !important;
        }
        .main_col{
            text-align: center;
        }
        .main_col ul li{
            text-align: center;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/overall_layouts/footer_links.vue